import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import styles from "./ReturnButton.module.scss";
import arrowBack from "../../../../assets/icons/arrowHeaderLeft.svg";

export const ReturnButton: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleReturn = () => {
    if (location.pathname === "/profile/cards") {
      navigate("/profile");
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      className={styles.returnButton}
      onClick={handleReturn}
      aria-label="Вернуться назад"
    >
      <img src={arrowBack} alt="back" />
    </button>
  );
};

